import { Box, Typography } from "@material-ui/core";
import { Button } from "components";
import { usePopup } from "hooks/usePopup";
import { useState } from "react";
import sellerService from "services/sellerService";
import { Dialog } from "shared";

export const DeleteConfirmDialog = ({
  open,
  onClose,
  onSuccess,
  certificate
}) => {
  const { addPopup } = usePopup();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!certificate?.id) return;

    try {
      setIsDeleting(true);
      await sellerService.deleteCertificate(certificate.id);

      addPopup({
        type: "success",
        title: "Certificado deletado com sucesso!",
        description: "O certificado foi removido do sistema."
      });

      onSuccess();
    } catch (error) {
      addPopup({
        type: "error",
        title: "Erro ao deletar certificado",
        description:
          error?.response?.data?.message || "Tente novamente mais tarde."
      });
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} handleClose={onClose} title="Confirmar Exclusão">
      <Box mb={3}>
        <Typography variant="body1" gutterBottom>
          Tem certeza que deseja deletar este certificado?
        </Typography>

        {certificate && (
          <Box
            mt={2}
            p={2}
            style={{ backgroundColor: "#f5f5f5", borderRadius: "4px" }}
          >
            <Typography variant="body2" style={{ marginBottom: "0.5rem" }}>
              <strong>Fornecedor:</strong> {certificate.seller_name}
            </Typography>
            <Typography variant="body2" style={{ marginBottom: "0.5rem" }}>
              <strong>Produto Base:</strong> {certificate.product_base_name}
            </Typography>
            <Typography variant="body2" style={{ marginBottom: "0.5rem" }}>
              <strong>Certificado:</strong> {certificate.name}
            </Typography>
            <Typography variant="body2">
              <strong>Certificadora:</strong> {certificate.certifier}
            </Typography>
          </Box>
        )}

        <Typography variant="body2" color="error" style={{ marginTop: "1rem" }}>
          Esta ação não pode ser desfeita.
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent="flex-end"
        gap={1}
        style={{ gap: "1rem" }}
      >
        <Button variant="outlined" onClick={onClose} disabled={isDeleting}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleDelete}
          isLoading={isDeleting}
        >
          Deletar
        </Button>
      </Box>
    </Dialog>
  );
};
